import { render } from "./DetailButton.vue?vue&type=template&id=4a0c105f"
import script from "./DetailButton.vue?vue&type=script&lang=js"
export * from "./DetailButton.vue?vue&type=script&lang=js"

import "./DetailButton.vue?vue&type=style&index=0&id=4a0c105f&lang=scss"
import "./DetailButton.vue?vue&type=style&index=1&id=4a0c105f&lang=scss"
import "./DetailButton.vue?vue&type=style&index=2&id=4a0c105f&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__